import { useNavigate, useParams } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import {
  OrderDeliveriesTable,
  OrderDocuments,
  OrderStatus,
} from './components';
import { useOrderQuery } from './order.generated';
import { useParameters } from '@web/utils/src';
import arrowTop from '@web/utils/src/assets/icons/functions/arrow-top.svg';
import { Document, Order, OrderStatus as OrderStatusType } from '@/types';

export function getStatus(t, status: OrderStatusType) {
  switch (status) {
    case OrderStatusType.Pending:
      return t('order.status.pending');
    case OrderStatusType.Confirmed:
      return t('order.status.confirmed');
    case OrderStatusType.Complete:
      return t('order.status.completed');
    case OrderStatusType.Cancelled:
      return t('order.status.cancelled');

    default:
      return status;
  }
}

type Params = {
  retailerId: string;
  orderId: string;
};
const SingleOrder = () => {
  const { orderId } = useParameters<Params>();
  const navigate = useNavigate();
  const { retailerId } = useParams();

  const [{ data }] = useOrderQuery({ variables: { orderId } });
  const order = data?.currentUser?.order;

  if (!order) {
    return null;
  }

  return (
    <>
      <div className="flex items-center py-2-0">
        <div
          className="h-full flex items-center px-1-0 pl-0 cursor-pointer opacity-70 hover:opacity-90"
          onClick={() => navigate(`/documents/${retailerId}/orders`)}
        >
          <ReactSVG src={arrowTop} className="text-white -rotate-90" />
        </div>
        <p className="text-2-0 font-bd">Order detials: {order.id}</p>
      </div>
      <div>
        {/* <div className="grid grid-cols-[2fr_3fr] gap-4-0 text-body1 mb-2-0"> */}
        <div className="flex justify-between gap-4-0 text-body1 mb-2-0">
          <OrderStatus status={order.status} />
          <OrderDocuments
            documents={order.documents as Document[]}
            className="w-2/5"
          />
        </div>
        <div>
          <OrderDeliveriesTable order={order as Order} />
        </div>
      </div>
    </>
  );
};

export default SingleOrder;
